.ugc-answer-lables-wrap {
  .sign-wrap {
    &:after {
      content: '|';
      font-size: 12px;
      margin: 0 8px;
      color: var(--gray-eleven);
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
}
